import LabelledPieceOfInfo from './LabelledPieceOfInfo';

export default LabelledPieceOfInfo;